import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { toast } from "sonner";

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const { processOAuthSession, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.replace('#', '')).get('session_id');

      if (!sessionId) {
        toast.error("No session found");
        navigate("/login");
        return;
      }

      try {
        const data = await processOAuthSession(sessionId);
        toast.success("Welcome to VEYRONIX!");
        
        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);
        
        // Redirect based on role
        if (data.user.role === "admin") {
          navigate("/admin", { state: { user: data.user } });
        } else if (data.user.role === "merchant") {
          navigate("/merchant", { state: { user: data.user } });
        } else {
          navigate("/dashboard", { state: { user: data.user } });
        }
      } catch (error) {
        toast.error("Authentication failed. Please try again.");
        navigate("/login");
      }
    };

    processAuth();
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="w-16 h-16 border-4 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin mx-auto" />
        <p className="text-slate-400 text-lg">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
